/** User-submitted links are data, never executable browser URLs. */
export function safeExternalUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' ? url.href : null;
  } catch { return null; }
}

export function safeYouTubeUrl(value: string | null | undefined): string | null {
  const href = safeExternalUrl(value);
  if (!href) return null;
  const host = new URL(href).hostname.toLowerCase();
  return ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtu.be'].includes(host) ? href : null;
}
